import { reactive } from 'vue'
import type { FormBaseColumns, FormRules } from '@pit-element-plus/components'

export type UseFormBaseState<T, K> = {
  formInline?: T
  addForm?: K
  columns?: FormBaseColumns
  // @ts-ignore
  rules?: FormRules<K>
}

export function useFormBaseState<
  T extends Record<string, any>,
  Form extends Record<string, any>,
>({
  formInline,
  addForm,
  columns,
  rules,
}: UseFormBaseState<T, Form>): UseFormBaseState<T, Form> {
  const state: UseFormBaseState<T, Form> = {
    // @ts-ignore
    formInline: reactive(formInline),
    // @ts-ignore
    addForm: reactive(addForm),
    // @ts-ignore
    columns: reactive(columns),
    // @ts-ignore
    rules: reactive<FormRules<Form>>(rules),
  }
  return state
}
